






































































































import { UserIcon, DeleteIcon, LogoutIcon } from 'tdesign-icons-vue';
import { defineComponent, computed, toRefs, getCurrentInstance } from '@vue/composition-api/dist/vue-composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import {
  isChinese,
  getDefaultColorByUserId,
  phoneCompose,
  getNameTipsDetail,
  isDisabledAllAuth,
} from '@/renderer/scripts/utils/tools/index';
import { SMH } from '@/renderer/scripts/smh';
import { checkRoleIsAdmin } from '@/renderer/scripts/utils/UserRole';
import user from '@/renderer/scripts/utils/user';
import { USER_ROLE_MAP } from '@/common/reporter/utils';
import { isAdminOrSuperAdmin } from '@/renderer/scripts/utils/UserRole/getters';
import { RoleMap } from '@/renderer/scripts/utils/ConstantConfig';
export default defineComponent({
  name: 'TeamOrMemberItem',
  props: {
    type: {
      required: true,
      type: String,
    },
    // 是否被禁用操作
    disable: {
      required: false,
      type: Boolean,
      default: false,
    },
    noDisableRoleSelect: {
      type: Boolean,
      default: false,
    },
    managerRoleMap: {
      required: false,
      default: () => new Map<Number, String>(),
    },
    // 节点信息
    item: {
      required: true,
      type: Object as () => CoFile.TeamOrMemberItem,
    },
  },
  components: {
    UserIcon,
    DeleteIcon,
    LogoutIcon,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const { userRole } = user.getUserInfo();
    const permissionMap: Record<number, string> = {
      1: i18n_t('继承'),
      2: i18n_t('继承'), // FIX: 默认权限也显示为继承
    };

    const { item, managerRoleMap } = toRefs(props);
    const util = {
      getDefaultColorByUserId,
      isChinese,
    };
    const simpleName = computed(() =>
      util.isChinese(item.value.name) ? item.value.name.substr(-2) : item.value.name.substr(0, 2),
    );

    // 根据对方的roleList匹配的roleName 取不到值， 就不展示了（展示数字也是不对的）
    const roleName = computed(() => managerRoleMap.value.get(Number(item.value.roleId)) || '');
    // style
    const roleStyle = computed(() => util.getDefaultColorByUserId(vm.$store.getters.userId));
    // 背景图片
    const roleBackgroundImg = computed(() => `url(${vm.$store.getters.protocol}:${item.value.avatar})`);
    // 当前item的类型
    const itemType = computed<'Team' | 'Member'>(() => (item.value.userId ? 'Member' : 'Team'));
    const renderRoleList = computed(() =>
      (vm.$store.getters.roles as SMH.Role[]).filter(role => {
        // 协作空间权限详情不显示操作者行
        const routeName = vm.$route.name as string;
        return !routeName.includes('collaborationSpace') || (!role.canAuthorize && !isDisabledAllAuth(role));
      }),
    );

    // 当前用户姓名
    const userId = computed(() => vm.$store.getters.userId);
    const orgId = computed(() => vm.$store.getters.orgId);
    // 是否是本人 且是当前企业
    const isMe = computed(
      () => itemType.value === 'Member' && item.value.userId === userId.value && item.value.orgId === orgId.value,
    );

    // 默认的tag标签[默认/继承]
    const showDefaultTag = computed<boolean>(
      () => item.value.roleId !== vm.$store.getters.ownerRole?.id && item.value.tag !== 0,
    );

    // 是否是群主
    const isGroupManager = computed<boolean>(() => item.value?.roleName === i18n_t('群主'));

    // 是否是一个人、且是外部用户
    // 注意：外部用户的定义是：当前登录人之外的其他企业人员
    const isExternal = computed(() => itemType.value === 'Member' && item.value.orgId !== orgId.value);

    // 显示的tag标签内容
    const tag = computed(
      () =>
        // if (isMe.value) return '本人';
        permissionMap[item.value.tag],
    );

    // 是否显示tag标签
    const disableOperate = computed(() => item.value.disabledOperate);
    // tag标签内的select是否可编辑
    // const selectAvailable = computed(() => item.value.disabledOperate || isMe);

    const methods = {
      editPermission: (item: CoFile.TeamOrMemberItem) => {
        // onAuthOperate('edit', item)
        context.emit('edit', item, itemType.value);
      },
      deleteByItem: (item: CoFile.TeamOrMemberItem) => {
        // onAuthOperate('delete', item)
        context.emit('delete', item, itemType.value);
      },
      quitByItem: (item: CoFile.TeamOrMemberItem) => {
        // onAuthOperate('delete', item)
        context.emit('quit', item, itemType.value);
      },
      canDelete() {
        if (props.type !== 'team-member') {
          return !props.disable;
        }
        // 非超管 或者 非管理员禁止没有删除
        if (!isAdminOrSuperAdmin.value) {
          return false;
        }
        if (userRole === RoleMap.SuperAdmin) {
          if (userId.value !== item.value.id) {
            return true;
          }
        }
        // 管理员可删除普通成员
        if (item.value.role === USER_ROLE_MAP.User) {
          return true;
        }
        return false;
      },
    };
    return {
      roleName,
      renderRoleList,
      itemType,
      util,
      methods,
      tag,
      orgId,
      isMe,
      isExternal,
      isGroupManager,
      showDefaultTag,
      disableOperate,
      userId,
      simpleName,
      roleStyle,
      roleBackgroundImg,
      phoneCompose,
      getNameTipsDetail,
      checkRoleIsAdmin,
    };
  },
});
